// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7n-4";
export var collapsed = "_7n-1";
export var headerBar = "_7n-0";
export var leftHeaderContent = "_7n-3";
export var subjectContainer = "_7n-2";